<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Assessment Regimes"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <div class="w-full flex ">
        <span class="mr-10"><b>Assessment Regimes </b></span>      
        <l-csv-import @on-import="onAssessmentRegimes" />
        <span class="mr-10"><b>Assessment Methods </b></span>      
        <l-csv-import @on-import="onAssessmentMethods" />
      </div>

    </l-container>

    <l-info-box
      class="mb-4"
      :active="assessmentRegimes.length > 0"
    >Right click a row to edit, delete or add a new record</l-info-box>

    <hot-table :data="assessmentRegimes" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Name" data="name" read-only="true"></hot-column>
      <!-- <hot-column title="Zone ID" data="zoneid" read-only="true"></hot-column> -->
      <hot-column title="Zone" data="zone_name" read-only="true"></hot-column>
      <!-- <hot-column title="Pollutant ID" data="pollutant" read-only="true"></hot-column> -->
      <hot-column title="Pollutant" data="pollutant_name" read-only="true"></hot-column>
      <hot-column title="Object Type" data="objecttype" read-only="true"></hot-column>
      <hot-column title="Reporting Metric" data="reportingmetric" read-only="true"></hot-column>
      <hot-column title="Protection Target" data="protectiontarget" read-only="true"></hot-column>
      <hot-column title="Threshold Classification Year" data="thresholdclassificationyear" read-only="true"></hot-column>
      <hot-column title="Threshold Classification Report" data="thresholdclassificationreport" read-only="true"></hot-column>
      <hot-column title="Assessment Threshold Exceedance" data="assessmentthresholdexceedance" read-only="true"></hot-column>
      <hot-column title="Include" data="include" read-only="true"></hot-column>
    </hot-table>

    <l-l-edit
      :showing="edit"
      @save="onSaveAssessmentRegimes"
      @close="edit = false"
      :assessmentRegimes="assessmentRegimes"
      :zones="zones"
      :pollutants="pollutants"
      :assessmenttypes="assessmenttypes"
      :objecttypes="objecttypes"
      :reportingmetrics="reportingmetrics"
      :protectiontargets="protectiontargets"
      :assessmentthresholdexceedances="assessmentthresholdexceedances"
      :assessmentdataAll="assessmentdataAll"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import AssessmentRegimesService from "./assessmentRegimes.service";


import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";

import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";

export default {
  name: "assessmentRegimes",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport
  },
  data() {
    return {
      edit: false,
      loading: false,
      assessmentRegimes: [],
      zones: [],
      pollutants: [],
      assessmenttypes: [],
      objecttypes: [],
      reportingmetrics: [],
      protectiontargets: [],
      assessmentthresholdexceedances: [],
      assessmentdataAll: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {}
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      
      this.assessmentRegimes = await AssessmentRegimesService.assessmentRegimes();
      this.zones = await AssessmentRegimesService.zones();
      this.pollutants = await AssessmentRegimesService.pollutants();
      this.assessmenttypes = await AssessmentRegimesService.assessmenttypes();
      this.objecttypes = await AssessmentRegimesService.objecttypes();
      this.reportingmetrics = await AssessmentRegimesService.reportingmetrics();
      this.protectiontargets = await AssessmentRegimesService.protectiontargets();
      this.assessmentthresholdexceedances = await AssessmentRegimesService.assessmentthresholdexceedances();
      this.assessmentdataAll = await AssessmentRegimesService.assessmentdataAll();
    },
    // async deleteAssessmentRegimes(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await AssessmentRegimesService.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         activeEditor.autoResize.unObserve = () => {};
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Assessment Regimes deleted!");
    //   }
    // },
    async saveAssessmentRegimes(ra) {
      const rowsAffected = await AssessmentRegimesService.update(ra.regime);

      await AssessmentRegimesService.updateData({ data: ra.dataUpdate})
      await AssessmentRegimesService.deleteData({ ids: ra.dataDelete.toString()});

      console.log("SAVED TO DB");
      const current = this.assessmentRegimes.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      };

    },
    async importAssessmentMethods(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await AssessmentRegimesService.importData(formData);
      this.assessmentRegimes = await AssessmentRegimesService.assessmentMethods();
      Notify.success("Assessment Methods imported!");
    },
    async onAssessmentMethods(file) {
      await Notify.loadData(
        "Importing Assessment Methods",
        this.importAssessmentMethods,
        file
      );
    },
    async importAssessmentRegimes(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await AssessmentRegimesService.import(formData);
      this.assessmentRegimes = await AssessmentRegimesService.assessmentRegimes();
      Notify.success("Assessment Regimes imported!");
    },
    async onAssessmentRegimes(file) {
      await Notify.loadData(
        "Importing Assessment Regimes",
        this.importAssessmentRegimes,
        file
      );
    },
    onEditAssessmentRegimes(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;

      var id = row.id;
      //var pollutantid = row.pollutant.substr(row.pollutant.lastIndexOf('/')+1);
      //var x  = AssessmentRegimesService.aassessmentdata(101,5);
      //xassessmentdata  = AssessmentRegimesService.aassessmentdata(id,pollutantid);

    },
    onNewAssessmentRegimes(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteAssessmentRegimes(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              const rowsAffected = await AssessmentRegimesService.delete(
                row.id
              );
              const activeEditor = hot.getActiveEditor();
              activeEditor.autoResize.unObserve = () => {};
              hot.alter("remove_row", clickedRow, 1);
            }
          );
          Notify.success("Assessment Regimes deleted!");
        }
      }, "This will delete all data connected to this Assessment Regime. <br/><br/>Do you want to continue?");
    },

    async onSaveAssessmentRegimes(assessmentregimes) {
      await Notify.loadData(
        "Saving changes to Assessment Regimes " + assessmentregimes.id,
        this.saveAssessmentRegimes,
        assessmentregimes
      );
      this.selected = {};
      Notify.loadData(null, this.loadInitialData);
    }
  }
};
</script>



